<script setup>
import { accessAlertState, closeAccessDeniedAlert } from "@/utils/accessAlert";
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="accessAlertState.show"
        class="fixed inset-0 z-[99999] flex items-center justify-center"
      >
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/60 backdrop-blur-sm"
          @click="closeAccessDeniedAlert"
        ></div>

        <!-- Dialog -->
        <div
          class="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden transform transition-all border border-gray-100"
        >
          <!-- Header Accent Banner -->
          <div
            class="h-2 bg-gradient-to-r from-amber-500 via-rose-500 to-red-500"
          ></div>

          <div class="p-6">
            <div class="flex items-start gap-4">
              <div
                class="flex-shrink-0 w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 shadow-inner"
              >
                <i class="ri-shield-keyhole-line text-2xl"></i>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-bold text-gray-900 m-0">
                  Akses Ditolak
                </h3>
                <p class="text-sm text-gray-600 mt-2 leading-relaxed">
                  {{ accessAlertState.message }}
                </p>
              </div>
            </div>
          </div>

          <!-- Action Footer -->
          <div
            class="px-6 py-4 bg-gray-50 flex justify-end border-t border-gray-100"
          >
            <button
              type="button"
              @click="closeAccessDeniedAlert"
              class="px-5 py-2.5 text-sm font-semibold text-white bg-rose-600 rounded-xl shadow-md hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2 transition-all duration-150"
            >
              Oke
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
